import React from 'react';
import SEOHead from './SEOHead';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <SEOHead 
        title="404 - Página não encontrada | Nukard"
        description="A página que você está procurando não foi encontrada. Explore nossas soluções digitais ou entre em contato conosco."
        canonical="https://nukard.com.br/404"
      />
      <div className="not-found">
      <div className="not-found__container">
        <div className="not-found__content">
          <div className="not-found__illustration">
            <div className="not-found__numbers">
              <span className="not-found__number not-found__number--4">4</span>
              <div className="not-found__icon">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                  <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <span className="not-found__number not-found__number--4">4</span>
            </div>
          </div>
          
          <div className="not-found__text">
            <h1 className="not-found__title">Página não encontrada</h1>
            <p className="not-found__description">
              Ops! A página que você está procurando não existe ou foi movida. 
              Que tal explorar nossas soluções digitais?
            </p>
          </div>
          
          <div className="not-found__actions">
            <a href="/" className="not-found__btn not-found__btn--primary">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 9L12 2L21 9V20A2 2 0 0119 22H5A2 2 0 013 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Voltar ao Início
            </a>
            <a href="#form-section" className="not-found__btn not-found__btn--secondary">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92V19A2 2 0 0120 21C10.6 21 3 13.4 3 4A2 2 0 015 2H7.08A1 1 0 018.08 2.92L9.54 7.24A1 1 0 019.3 8.3L7.5 10.1C8.72 12.67 11.33 15.28 13.9 16.5L15.7 14.7A1 1 0 0116.76 14.46L21.08 15.92A1 1 0 0122 16.92Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Falar Conosco
            </a>
          </div>
          
          <div className="not-found__suggestions">
            <h3 className="not-found__suggestions-title">Páginas mais acessadas:</h3>
            <ul className="not-found__suggestions-list">
              <li><a href="#benefits">Nossos Benefícios</a></li>
              <li><a href="#solutions">Nossas Soluções</a></li>
              <li><a href="#form-section">Solicitar Orçamento</a></li>
              <li><a href="https://wa.me/5541995253523" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
            </ul>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

export default NotFound;
